import { css } from '@/styled-system/css';

export const textOverflow = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
